<template>
  <div :class="!isMatching() && $route.meta.fixedHeader ? 'fixed-header' : ''">
    <EventBanner v-if="$route.path === '/' && isMatching()" id="EventBanner" />
    <header>
      <div v-if="$route.path !== '/signup/tally'">
        <div
          class="container"
          v-if="userIsAuthenticated"
          style="display: flex; align-items: center; justify-content: space-between">
          <div style="display: flex; align-items: center">
            <a class="px-4 hidden-md-and-up" @click="toggleDrawer"><v-icon>mdi-menu</v-icon></a>
            <router-link
              class="pl-4 hidden-sm-and-down"
              :to="
                $route.path.indexOf('/campaign') > -1 || $route.path.indexOf('regcam') > -1 || isMatching()
                  ? '/campaign/search/'
                  : '/company/report/'
              ">
              <img
                v-if="isMatching()"
                :src="require('@/assets/img/matching-logo.png')"
                class="header-logo"
                :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : ''" />
              <img
                v-else
                :src="require('@/assets/img/logo.png')"
                class="header-logo"
                :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : ''" />
            </router-link>

            <!-- 로그인 상태에서도 네비게이션 메뉴 표시 (데스크탑만) -->
            <ul
              class="header-button hidden-sm-and-down"
              v-if="!isMatching()"
              style="list-style: none; display: flex; align-items: center; gap: 0; margin: 0">
              <li>
                <a
                  class="pr-8 pl-6"
                  @click.prevent="
                    sendEventInRouterLink('/serviceGuide', {
                      event: 'clickGnb',
                      page: 'authenticated',
                      objectSection: 'gnb',
                      objectType: 'button',
                      objectId: 'serviceGuide',
                      objectName: '서비스 소개',
                    })
                  "
                  >서비스 소개</a
                >
              </li>
              <li>
                <a
                  class="pr-8"
                  @click.prevent="
                    sendEventInRouterLink('/price/', {
                      event: 'clickGnb',
                      page: 'authenticated',
                      objectSection: 'gnb',
                      objectType: 'button',
                      objectId: 'price',
                      objectName: '가격 안내',
                    })
                  "
                  >가격 안내</a
                >
              </li>
              <li>
                <a
                  class="pr-8"
                  @click.prevent="
                    sendEventInRouterLink('/blog', {
                      event: 'clickGnb',
                      page: 'authenticated',
                      objectSection: 'gnb',
                      objectType: 'button',
                      objectId: 'ceoBlog',
                      objectName: '고객 사례',
                    })
                  "
                  >고객 사례</a
                >
              </li>
              <li>
                <a
                  class="pr-8"
                  @click.prevent="
                    sendEventInRouterLink('/faq/', {
                      event: 'clickGnb',
                      page: 'authenticated',
                      objectSection: 'gnb',
                      objectType: 'button',
                      objectId: 'qna',
                      objectName: '자주 묻는 질문',
                    })
                  "
                  >자주 묻는 질문</a
                >
              </li>
            </ul>
          </div>

          <div>
            <v-row class="pt-1">
              <v-col
                class="pt-2"
                v-if="points.length > 0 && propositions != undefined && user.email !== 'test@supermembers.co.kr'">
                <span style="color: #bd1328"> ₩{{ availPoints | numFormat }} </span>
                <router-link
                  :to="isMatching() ? '/campaign/charge' : '/company/charge'"
                  class="shades--text text--black">
                  충전 금액</router-link
                >
              </v-col>
              <v-col>
                <ul style="list-style: none">
                  <li>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-y z-index="1000">
                      <template v-slot:activator="{ on }">
                        <v-btn text v-on="on">
                          <span v-if="head">
                            <v-icon color="secondary" size="27">mdi-account-supervisor-circle</v-icon>
                            <span v-if="user && user.id !== (head || {}).id">
                              <v-icon color="default-light" size="16">mdi-chevron-right</v-icon>
                            </span>
                          </span>
                          <v-icon v-if="user && user.id !== (head || {}).id" color="#15c072" size="27"
                            >mdi-account-circle</v-icon
                          >
                          <span class="ml-2 body-1 text-left" style="line-height: 1rem">
                            <span>{{ (user && user.charger) || '사장님' }}</span>
                            <span class="secondary--text" v-if="head">본사</span><br /><span
                              class="caption warm-grey--text"
                              >{{ user && user.name }}</span
                            >
                          </span>
                          <v-icon color="warm-grey">mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-card>
                        <v-list>
                          <v-list-item @click="changeBranch(head)">
                            <v-list-item-avatar>
                              <v-icon color="secondary" size="27">{{
                                head ? 'mdi-account-supervisor-circle' : 'mdi-account-circle'
                              }}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title style="line-height: 1.5rem"
                                >{{ head ? (head || {}).charger : user.charger }}
                                <span class="secondary--text" v-if="head"><br />본사</span></v-list-item-title
                              >
                              <v-list-item-subtitle class="caption warm-grey--text" style="line-height: 1.5rem">{{
                                head ? head.name : user.name
                              }}</v-list-item-subtitle>

                              <v-list-item-subtitle
                                v-if="isMatching() && isAdminMode === true"
                                @click.stop="goToAdminRoot"
                                class="caption warm-grey--text"
                                style="line-height: 1.5rem"
                                ><v-icon size="12">mdi-chevron-double-up</v-icon
                                ><span class="warm-grey--text">루트 계정으로 이동</span></v-list-item-subtitle
                              >

                              <v-list-item-subtitle
                                @click="$router.push('/logout')"
                                class="caption warm-grey--text"
                                style="line-height: 1.5rem; cursor: pointer"
                                ><v-icon size="12">mdi-logout-variant</v-icon
                                ><span class="warm-grey--text">로그아웃</span></v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <v-list>
                          <v-list-item v-for="(branch, idx) in branches" :key="idx" @click="changeBranch(branch)">
                            <v-list-item-avatar>
                              <v-icon color="warm-grey" size="27">{{
                                user && user.id === branch.id ? 'mdi-check-circle' : 'mdi-account-circle'
                              }}</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title style="line-height: 1.5rem">{{ branch.charger }}</v-list-item-title>
                              <v-list-item-subtitle class="caption warm-grey--text" style="line-height: 1.5rem">{{
                                branch.name
                              }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </div>
        <div v-else class="container">
          <router-link to="/">
            <img
              :src="isMatching() ? require('../../assets/img/matching-logo.png') : require('../../assets/img/logo.png')"
              class="header-logo"
              :class="$vuetify.breakpoint.smAndDown ? 'pl-4' : 'ml-6'" />
          </router-link>
          <ul class="header-button">
            <!--            <li v-if="!isMatching()">-->
            <!--              <router-link to="/aibaek/" class="shades&#45;&#45;text text&#45;&#45;black">-->
            <!--                AI백선생-->
            <!--              </router-link>-->
            <!--            </li>-->
            <div v-if="!isMatching()" class="w-full d-flex justify-space-between">
              <div class="d-flex ml-4">
                <li>
                  <a
                    class="pr-8 pl-6"
                    @click.prevent="
                      sendEventInRouterLink('/serviceGuide', {
                        event: 'clickGnb',
                        page: 'storeLanding',
                        objectSection: 'gnb',
                        objectType: 'button',
                        objectId: 'serviceGuide',
                        objectName: '서비스 소개',
                      })
                    "
                    >서비스 소개</a
                  >
                </li>
                <li>
                  <a
                    class="pr-8"
                    @click.prevent="
                      sendEventInRouterLink('/price/', {
                        event: 'clickGnb',
                        page: 'storeLanding',
                        objectSection: 'gnb',
                        objectType: 'button',
                        objectId: 'price',
                        objectName: '가격 안내',
                      })
                    "
                    >가격 안내</a
                  >
                </li>
                <li>
                  <a
                    class="pr-8"
                    @click.prevent="
                      sendEventInRouterLink('/blog', {
                        event: 'clickGnb',
                        page: 'storeLanding',
                        objectSection: 'gnb',
                        objectType: 'button',
                        objectId: 'ceoBlog',
                        objectName: '고객 사례',
                      })
                    "
                    >고객 사례</a
                  >
                </li>
                <li>
                  <a
                    @click.prevent="
                      sendEventInRouterLink('/faq/', {
                        event: 'clickGnb',
                        page: 'storeLanding',
                        objectSection: 'gnb',
                        objectType: 'button',
                        objectId: 'qna',
                        objectName: '자주 묻는 질문',
                      })
                    "
                    >자주 묻는 질문</a
                  >
                </li>
              </div>
              <div class="gap-4">
                <li>
                  <a
                    href="https://rank.supermembers.co.kr/"
                    class="pr-8 d-flex align-center"
                    @click="
                      pushDataLayer({
                        event: 'clickGnb',
                        page: 'storeLanding',
                        objectSection: 'gnb',
                        objectType: 'button',
                        objectId: 'appDown',
                        objectName: '블로거용 사이트',
                      })
                    "
                    >블로거용 사이트
                    <v-icon size="16" color="#3A3A3A" class="ml-2">mdi-open-in-new</v-icon>
                  </a>
                </li>
                <li>
                  <a
                    class="pr-8"
                    @click="
                      sendEventInRouterLink(
                        signInLink,
                        {
                          event: 'clickGnb',
                          page: 'storeLanding',
                          objectSection: 'gnb',
                          objectType: 'button',
                          objectId: 'gotoLoginPage',
                          objectName: '로그인',
                        },
                        {
                          event: 'clickLoginBtn',
                          page: 'storeLanding',
                          objectSection: 'gnb',
                          objectType: 'button',
                          objectId: 'gotoLoginPage',
                          objectName: '로그인',
                        }
                      )
                    "
                    >로그인/회원가입</a
                  >
                </li>

                <v-btn
                  class="white-two--text mr-4"
                  color="#EA2A3A"
                  @click="
                    clickLeadCtaBtn();
                    pushDataLayer({
                      event: 'clickGnb',
                      page: 'storeLanding',
                      objectSection: 'gnb',
                      objectType: 'button',
                      objectId: 'leadCta',
                      objectName: '무료 상담',
                    });
                  ">
                  무료 상담
                </v-btn>

                <v-row justify="center" align="center" style="max-height: 0px">
                  <LeadModal :showModal.sync="showLeadModal" :sourceRoute="leadModalSourceRoute" />
                </v-row>
              </div>
            </div>
            <div v-else class="w-full d-flex justify-end">
              <li>
                <router-link to="/signin/" class="shades--text text--black mr-4">광고주 로그인</router-link>
              </li>
            </div>
          </ul>
          <div class="mobile">
            <v-btn
              class="white-two--text mr-3"
              color="#EA2A3A"
              @click="
                clickLeadCtaBtn();
                pushDataLayer({
                  event: 'clickGnb',
                  page: 'storeLanding',
                  objectSection: 'gnb',
                  objectType: 'button',
                  objectId: 'leadCta',
                  objectName: '무료 상담',
                });
              "
              v-if="!isMatching() && $route.name !== 'MarketingSurvey'">
              무료 상담
            </v-btn>
            <v-icon
              class="mr-3"
              @click="
                toggleDrawer();
                pushDataLayer({
                  event: 'clickCategory',
                  page: 'storeLanding',
                  objectSection: 'gnb',
                  objectType: 'category',
                  objectId: 'hamburger',
                  objectName: 'hamburger',
                });
              "
              >mdi-menu</v-icon
            >
          </div>
        </div>
      </div>
    </header>
    <!-- 모바일 SNB -->
    <div id="header-mobile" :class="mobileClass" @click="toggleDrawer">
      <ul v-if="userIsAuthenticated">
        <li class="profile" v-if="$route.path.indexOf('/regcam') > -1 || isMatching()">
          <router-link to="/campaign/search/">
            <img
              :src="companyImage"
              style="width: 32px; height: 32px; border-radius: 50%; vertical-align: middle; margin-right: 10px" />
            {{ company ? company.name : '' }}
          </router-link>
        </li>
        <li class="profile" v-else>
          <router-link to="/company/report/">
            <img
              :src="companyImage"
              style="width: 32px; height: 32px; border-radius: 50%; vertical-align: middle; margin-right: 10px" />
            {{ company ? company.name : '' }}
          </router-link>
        </li>
        <div v-if="$route.path.indexOf('/campaign') > -1" class="scroll">
          <li>
            <router-link
              :to="{ name: 'Regcam', params: { channel: 'naver' } }"
              class="body-1 font-weight-bold"
              style="color: #484848"
              >새 캠페인 만들기</router-link
            >
          </li>
          <v-divider></v-divider>
          <li>
            <router-link to="/campaign/search" class="body-1 font-weight-bold" style="color: #484848"
              >블로거 검색</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/proposition" class="body-1 font-weight-bold" style="color: #484848"
              >직접 제안하기</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/autoproposition" class="body-1 font-weight-bold" style="color: #484848"
              >자동 제안하기</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/list" class="body-1 font-weight-bold" style="color: #484848"
              >블로거 캠페인 목록</router-link
            >
            <ul style="margin-top: -16px">
              <li v-for="(campaign, i) in campaigns.filter(campaign => campaign.naver)" :key="i">
                <router-link
                  :to="{
                    name: 'CampaignDetail',
                    params: { index: i, campaign: campaign },
                  }"
                  class="body-1 ml-4"
                  style="color: #484848"
                  >{{ campaign.name }}</router-link
                >
              </li>
            </ul>
          </li>
          <v-divider></v-divider>
          <li>
            <router-link to="/campaign/searchyoutube" class="body-1 font-weight-bold" style="color: #484848"
              >유튜버 검색</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/proposition" class="body-1 font-weight-bold" style="color: #484848"
              >직접 제안하기</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/list" class="body-1 font-weight-bold" style="color: #484848"
              >유튜브 캠페인 목록</router-link
            >
            <ul style="margin-top: -16px">
              <li v-for="(campaign, i) in campaigns.filter(campaign => campaign.youtube)" :key="i">
                <router-link
                  :to="{
                    name: 'CampaignDetail',
                    params: { index: i, campaign: campaign },
                  }"
                  class="body-1 ml-4"
                  style="color: #484848"
                  >{{ campaign.name }}</router-link
                >
              </li>
            </ul>
          </li>
          <v-divider></v-divider>
          <li>
            <router-link to="/campaign/searchtiktok" class="body-1 font-weight-bold" style="color: #484848"
              >틱톡커 검색</router-link
            >
          </li>
          <v-divider></v-divider>
          <li>
            <router-link to="/campaign/charge" class="body-1 font-weight-bold" style="color: #484848"
              >충전금액 관리</router-link
            >
          </li>
          <li>
            <router-link to="/campaign/editinfo" class="body-1 font-weight-bold" style="color: #484848"
              >담당자 정보수정</router-link
            >
          </li>
          <li>
            <router-link to="/logout" class="body-1 font-weight-bold" style="color: #484848">로그아웃</router-link>
          </li>
        </div>
        <div v-else class="scroll" style="position: relative">
          <!--        <li><router-link to="/company/dashboard">알림 현황</router-link></li>-->
          <li>
            <a
              @click="
                sendEventInRouterLink('/company/report', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'marketingReport',
                  objectName: '마케팅 보고서',
                })
              "
              >마케팅 보고서</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/company/contract', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'review',
                  objectName: '이용 관리',
                })
              "
              >이용 관리</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/company/modads', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'ads',
                  objectName: '광고 관리',
                })
              "
              >광고 관리</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/company/pay', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'payments',
                  objectName: '결제 관리',
                })
              "
              >결제 관리</a
            >
          </li>
          <li v-if="!hideSettlement">
            <a
              @click="
                sendEventInRouterLink('/company/settlement', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'settlement',
                  objectName: '정산 관리',
                })
              "
              >정산 관리</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/company/editinfo', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'editProfile',
                  objectName: '담당자 정보수정',
                })
              "
              >담당자 정보수정</a
            >
          </li>
          <v-divider></v-divider>
          <li>
            <a
              @click="
                sendEventInRouterLink('/price/', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'price',
                  objectName: '가격 안내',
                })
              "
              >가격 안내</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/serviceGuide', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'serviceGuide',
                  objectName: '서비스 소개',
                })
              "
              >서비스 소개</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/blog', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'ceoBlog',
                  objectName: '고객 사례',
                })
              "
              >고객 사례</a
            >
          </li>
          <li>
            <a
              @click="
                sendEventInRouterLink('/faq/', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'qna',
                  objectName: '자주 묻는 질문',
                })
              "
              >자주 묻는 질문</a
            >
          </li>
          <li>
            <a
              href="/"
              @click="
                pushDataLayer({
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'supermembers',
                  objectName: '슈퍼멤버스 소개',
                })
              "
              >슈퍼멤버스 소개</a
            >
          </li>
          <li style="position: absolute; bottom: 20px; left: 0; right: 0">
            <a
              style="color: var(--default, #3a3a3a)"
              @click="
                sendEventInRouterLink('/logout', {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'logout',
                  objectName: '로그아웃',
                })
              "
              >로그아웃</a
            >
          </li>
        </div>
      </ul>
      <ul v-else>
        <li v-if="!isMatching()">
          <a
            href="/serviceGuide"
            @click="
              sendEventInRouterLink('/serviceGuide', {
                event: 'clickCategoryMenu',
                objectSection: 'category',
                objectType: 'button',
                objectId: 'serviceGuide',
                objectName: '서비스 소개',
              })
            "
            >서비스 소개</a
          >
        </li>
        <li v-if="!isMatching()">
          <a
            href="/price/"
            @click="
              sendEventInRouterLink('/price/', {
                event: 'clickCategoryMenu',
                objectSection: 'category',
                objectType: 'button',
                objectId: 'price',
                objectName: '가격 안내',
              })
            "
            >가격 안내</a
          >
        </li>
        <li v-if="!isMatching()">
          <a
            href="/blog"
            @click="
              sendEventInRouterLink('/blog', {
                event: 'clickCategoryMenu',
                objectSection: 'category',
                objectType: 'button',
                objectId: 'ceoBlog',
                objectName: '고객 사례',
              })
            "
            >고객 사례</a
          >
        </li>
        <li v-if="!isMatching()">
          <a
            href="/faq/"
            @click="
              sendEventInRouterLink('/faq/', {
                event: 'clickCategoryMenu',
                objectSection: 'category',
                objectType: 'button',
                objectId: 'qna',
                objectName: '자주 묻는 질문',
              })
            "
            >자주 묻는 질문</a
          >
        </li>
        <li v-if="!isMatching()">
          <a
            @click="
              sendEventInRouterLink(
                '/signin/',
                {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'gotoLoginPage',
                  objectName: '로그인',
                },
                {
                  event: 'clickLoginBtn',
                  page: 'storeLanding',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'gotoLoginPage',
                  objectName: '로그인',
                }
              )
            "
            >로그인</a
          >
        </li>
        <li v-if="!isMatching()">
          <a
            @click.prevent="
              sendEventInRouterLink(
                '/signup/',
                {
                  event: 'clickCategoryMenu',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'signup',
                  objectName: '회원가입',
                },
                {
                  event: 'clickSignupBtn',
                  page: 'storeLanding',
                  objectSection: 'category',
                  objectType: 'button',
                  objectId: 'gotoSignupPage',
                  objectName: '회원가입',
                }
              )
            "
            >회원가입</a
          >
        </li>
        <li v-if="isMatching()">
          <router-link to="/signin/">광고주 로그인</router-link>
        </li>
        <li v-if="!isMatching()" class="blogger-site-link">
          <a
            href="https://rank.supermembers.co.kr/"
            class="d-flex align-center"
            @click="
              pushDataLayer({
                event: 'clickCategoryMenu',
                objectSection: 'category',
                objectType: 'button',
                objectId: 'appDown',
                objectName: '블로거용 사이트',
              })
            "
            >블로거용 사이트
            <v-icon size="16" color="#3A3A3A" class="ml-2">mdi-open-in-new</v-icon>
          </a>
        </li>
      </ul>
    </div>
    <div v-if="isShowBanner() && !!partnerBanner.length" style="width: 100%; height: 80px">
      <slick ref="slick" :options="slickOptions">
        <div
          v-for="item in partnerBanner"
          :key="item.link"
          style="height: 80px; width: 100vw; cursor: pointer"
          @click="openPartnerSite(item.link)">
          <div
            :style="{
              height: '80px',
              backgroundImage: `url('${item.bg}')`,
              backgroundRepeat: 'round',
            }">
            <img style="margin: 0 auto; height: 80px" :src="$vuetify.breakpoint.mdAndUp ? item.content : item.mobile" />
          </div>
        </div>
      </slick>
    </div>
  </div>
</template>

<script>
import userMixin from '../shared/userMixin';
import companyMixin from '../shared/companyMixin';
import campaignMixin from '../shared/campaignMixin';
import EventBanner from '@/components/landing/EventBanner';
import { EventBus } from '@/components/shared/event-bus';
import Slick from 'vue-slick';
import LeadModal from '@/components/lead/modal/LeadModal';
import { STORE_PAGE_HEADER, PRODUCT_PAGE_HEADER } from '@/locales/ko/ad';
import firebase from '@firebase/app';
import { pushDataLayer } from '@/utils';

export default {
  name: 'Header',
  mixins: [userMixin, companyMixin, campaignMixin],
  components: {
    LeadModal,
    EventBanner,
    Slick,
  },
  data() {
    return {
      companyImage: this.isMatching() ? require('@/assets/img/matching-logo.png') : require('@/assets/img/logo.png'),
      mobileClass: ['fade'],
      menu: false,
      // screenWidth: window.innerWidth,
      propositions: [],
      propositionAutos: [],
      hideSettlement: false,
      showLeadModal: false,
      storePageHeader: STORE_PAGE_HEADER,
      productPageHeader: PRODUCT_PAGE_HEADER,
      slickOptions: {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        variableWidth: true,
        slidesToShow: 1,
      },
      partnerBanner: [
        {
          mobile: require('@/assets/img/partner/맥형띠배너_mobile.png'),
          content: require('@/assets/img/partner/맥형띠배너_desktop.png'),
          bg: require('@/assets/img/partner/맥형띠배너bg_desktop.png'),
          link: '/partner-detail',
        },

        // {
        //   link: 'https://bit.ly/3Oi3PPY',
        //   mobile: require('@/assets/img/partner/partner1_mobile.png'),
        //   bg: require('@/assets/img/partner/partner1_bg.png'),
        //   content: require('@/assets/img/partner/partner1_content.png'),
        // },
      ],
      clickLeadCtaBtnDebounce: null, // debounce 타이머
    };
  },
  computed: {
    // availablePoint() {
    //   return (this.points[0].balance - this._.sumBy(this.propositions, 'point') - this._.sumBy(this.propositionAutos, 'budget'));
    // }
    isAdminMode() {
      return this.$store.getters.adminMode;
    },
    getAdminLoginInfo() {
      if (this.$store.getters.adminMode) {
        return this.$store.getters.adminLoginInfo;
      } else return null;
    },

    signInLink() {
      if (this.$route.path === '/payhere' || this.$route.path === '/payhere/') {
        return { path: '/signin/', query: { recommended: '페이히어' } };
      }
      return '/signin/';
    },

    leadModalSourceRoute() {
      // 현재 라우트에 따라 LeadModal의 sourceRoute 결정
      const path = this.$route.path;

      if (path === '/blog' || path === '/blog/') {
        return 'ceoBlog';
      } else if (path.startsWith('/contents/')) {
        return 'contentsDetail';
      } else if (path === '/price' || path === '/price/') {
        return 'price';
      } else if (path.startsWith('/serviceGuide')) {
        return 'serviceGuide';
      } else if (path === '/' || path === '/landing/') {
        // 랜딩 페이지에서는 기본값 storeLanding
        return 'storeLanding';
      }

      // 기타 페이지에서는 기본값
      return 'storeLanding';
    },
  },
  watch: {
    company() {
      this.companyImage =
        (this.company || {}).thumbnail ||
        (this.isMatching() ? require('@/assets/img/matching-logo.png') : require('@/assets/img/logo.png'));
    },
    $route() {
      // 라우트 변경 시 유저 메뉴 닫기
      this.menu = false;
    },
  },
  methods: {
    clickLeadCtaBtn() {
      console.log('🔵 [Header] clickLeadCtaBtn called');

      // 쿼리 파라미터로 이미 모달이 열렸는지 체크 (최우선)
      const alreadyOpenedByQuery = sessionStorage.getItem('leadModalOpenedByQuery');
      console.log('🔍 [Header] sessionStorage leadModalOpenedByQuery:', alreadyOpenedByQuery);

      if (alreadyOpenedByQuery === 'true') {
        console.log('⚠️ [Header] Modal already opened by query parameter, skipping');
        return;
      }

      // 이미 모달이 열려있으면 무시
      console.log('🔍 [Header] showLeadModal:', this.showLeadModal);
      if (this.showLeadModal) {
        console.log('⚠️ [Header] Modal already opened, skipping');
        return;
      }

      // debounce 체크
      if (this.clickLeadCtaBtnDebounce) {
        console.log('⚠️ [Header] Click ignored (debounced)');
        return;
      }

      console.log('✅ [Header] Opening modal from button click');

      // debounce 타이머 설정 (2초)
      this.clickLeadCtaBtnDebounce = setTimeout(() => {
        this.clickLeadCtaBtnDebounce = null;
      }, 2000);

      this.showLeadModal = true;

      // 현재 페이지에 따라 page 값 설정
      let page = 'storeLanding'; // 기본값
      const path = this.$route.path;

      if (path.startsWith('/price')) {
        page = 'price';
      } else if (path === '/blog') {
        page = 'ceoBlog';
      } else if (path.startsWith('/blog/')) {
        page = 'contentsDetail';
      } else if (path.startsWith('/serviceGuide')) {
        page = 'serviceGuide';
      }
      // productLanding은 추후 개발 시 추가

      pushDataLayer({
        event: 'clickLeadCta',
        page: page,
        objectType: 'button',
        objectSection: 'gnb',
        objectId: 'openLeadForm',
        objectName: '무료 상담',
      });
    },

    pushDataLayer(event) {
      const page = this.$route.path.indexOf('/company') > -1 ? 'marketingReport' : 'storeLanding';
      pushDataLayer({ page, ...event }); // object에 page가 존재 시 object의 값을 우선함
    },

    async sendEventInRouterLink(link, ...events) {
      try {
        console.log('🔵 [Header] sendEventInRouterLink 호출:', link);
        events.forEach(event => {
          pushDataLayer({ ...event });
        });

        await this.$router.push(link);
        console.log('✅ [Header] 라우터 이동 완료:', link);
      } catch (e) {
        console.error('🔴 [Header] 라우터 이동 에러:', link, e);
      }
    },

    toggleDrawer() {
      let idx = this.mobileClass.indexOf('fade');
      if (idx > -1) {
        this.mobileClass.splice(idx, 1);
      } else {
        this.mobileClass.push('close');
        window.setTimeout(() => {
          let idx = this.mobileClass.indexOf('close');
          if (idx > -1) {
            this.mobileClass.splice(idx, 1);
            this.mobileClass.push('fade');
          }
        }, 300);
      }
    },
    async changeBranch(branch) {
      // 로그아웃 상태에서 branch가 null일 수 있음
      if (!branch || !this.user) {
        return;
      }
      await this.$store.dispatch('changeUser', branch);
      location.reload();
    },
    goToAdminRoot() {
      if (!this.$store.getters.adminMode) return;

      if (
        !this.$store.getters.adminLoginInfo ||
        !this.$store.getters.adminLoginInfo.email ||
        !this.$store.getters.adminLoginInfo.password
      ) {
        this.$store.commit('setMsg', '로그인 정보가 없습니다.');
        this.$store.commit('setShowSnackbar', true);
        return;
      }

      let logoutFunc = this.$store.dispatch('logout');
      logoutFunc
        .then(() =>
          this.$store.dispatch('signUserIn', {
            email: this.$store.getters.adminLoginInfo.email,
            password: this.$store.getters.adminLoginInfo.password,
            matching: true,
          })
        )
        .then(user => {
          if (user && this.userIsAuthenticated) {
            this.axios
              .put('/company/user', {
                id: user.id,
                last_login_matching: new Date(),
              })
              .then(() => {
                this.$router.push('/campaign/search');
              });
          } else {
            this.$store.commit('setMsg', '처리 중 오류가 발생했습니다.');
            this.$store.commit('setShowSnackbar', true);
          }
        });
    },
    isMatching() {
      return process.env.VUE_APP_TARGET === 'campaign' || location.href.indexOf('superchart') > -1;
    },
    isShowBanner() {
      return !this.isMatching() && location.pathname.includes('/company');
    },
    openPartnerSite(link) {
      console.log(link);

      pushDataLayer({
        event: 'clickBanner',
        page: 'marketingReport',
        objectSection: 'top',
        objectType: 'banner',
        objectId: 'macbroAcademy',
        objectName: 'macbroAcademy',
      });

      window.open(link, '_blank');
    },
    async updatePoint() {
      try {
        if (this.campaigns.length > 0 && !!firebase.auth().currentUser) {
          let filterCampaign = '';
          this.campaigns.map(campaign => {
            filterCampaign += '&campaignId[]=' + campaign.id;
          });
          let propositions = await this.axios.get('/campaign/proposition/v2?status=1' + filterCampaign);
          this.propositions = propositions.data.propositions; //.filter((p) => !p.propositionAutoId);

          // let propositionAutos = await this.axios.get('/campaign/propositionAuto?status[]=1&status[]=2' + filterCampaign);
          // this.propositionAutos = propositionAutos.data.propositionAutos;
        }

        if (this.user && this.user.id && firebase.auth().currentUser) {
          if (this.isMatching()) {
            let points = await this.axios.get(`company/user/point?companyId=${this.user.id}&orderBy=id&direction=desc`);
            if (points.data.total > 0) {
              let prPropositions = this.propositions.filter(proposition => {
                return this._.find(this.campaigns, {
                  id: proposition.campaignId,
                  deliveryMethod: 'PR',
                });
              });
              this.$store.commit('setPoints', points.data.companyPoints);
              this.$store.commit(
                'setWaitPoints',
                this._.sumBy(this.propositions, 'point') +
                  this._.sumBy(prPropositions, 'cprice') +
                  this._.sumBy(prPropositions, 'rewardFeeAmount') /* + this._.sumBy(this.propositionAutos, 'budget')*/
              );
              this.$store.commit(
                'setAvailPoints',
                this.points[0].balance -
                  (this._.sumBy(this.propositions, 'point') +
                    this._.sumBy(prPropositions, 'cprice') +
                    this._.sumBy(
                      prPropositions,
                      'rewardFeeAmount'
                    )) /* + this._.sumBy(this.propositionAutos, 'budget')*/
              );
            } else {
              this.$store.commit('setPoints', []);
              this.$store.commit('setAvailPoints', 0);
              this.$store.commit('setWaitPoints', 0);
            }
          } else {
            let points;
            points = await this.axios.get(
              `company/user/sumempoint?companyId=${this.user.id}&orderBy=id&direction=desc`
            );

            if (points && points.data.total > 0) {
              this.$store.commit('setPoints', points.data.sumemPoints);
              this.$store.commit('setWaitPoints', 0);
              this.$store.commit('setAvailPoints', this.points[0].balance);
            } else {
              this.$store.commit('setPoints', []);
              this.$store.commit('setAvailPoints', 0);
              this.$store.commit('setWaitPoints', 0);
            }
          }
        }
        this.propositions = this.propositions || [];
      } catch (e) {
        console.log(e);
      }
    },
  },
  async created() {
    await this.updatePoint();
    EventBus.$on('update:point', async () => {
      await this.updatePoint();
    });

    this.hideSettlement = this.companies.some(company => {
      return !(company.category.firstName === '제품');
    });
  },
};
</script>

<style scoped lang="scss">
.fixed-header {
  position: sticky;
  top: 0;
  z-index: 1000 !important;
}

header {
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid var(--disabled_light, #f5f5f5);
  // box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.25);
  z-index: 1001;
  margin: 0;
  background-color: #fff;
  line-height: normal;
  font-size: 13px;
}

@media (min-width: 960px) {
  header {
    min-width: 960px;
  }
  .container {
    min-width: 100%;
  }
}

header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0;
  padding-top: 0;
  height: 64px;
}
.bg-color--white {
  background-color: #fff;
}

.bg-color--gray {
  background-color: #fdfdfd;
}

header .container.ads {
  justify-content: left;
}

.header-logo {
  margin: 16px 4px;
  height: 28px;
}
.header-logo.ads {
  margin: 16px 40px 16px 20px;
  height: 28px;
}

.header-button {
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
}

.header-button li {
  display: inline-block;
  text-align: center;
  cursor: pointer;
}

::v-deep .header-button a {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--default, #3a3a3a) !important;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  height: 64px;
}

.header-button li:last-child a {
  margin-right: 0;
}

.header-button .disable > a {
  color: #a2a2a2;
}

.header-button li:hover > a {
  color: #ff5a5f;
}

.header-button a:hover {
  color: #ff5a5f;
}

.header-button.mobile {
  display: none;
}

#header-mobile {
  display: none;
}

#header-mobile .header-logo {
  margin-bottom: 0;
}

@media (max-width: 960px) {
  h2 {
    font-size: 14px;
  }
  .header-logo {
    height: 24px;
    margin: 18px 2px 14px 2px;
  }
  .header-logo.ads {
    margin: 11px 16px 10px 20px !important;
    height: 27px;
  }
  .header-button {
    display: none;
  }
  .header-button.mobile {
    display: inline-block;
  }
  #header-mobile {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 5;
  }
  #header-mobile ul {
    position: fixed;
    list-style: none;
    top: 0;
    bottom: 0;
    left: 0;
    margin: 0;
    padding: 10px 0;
    background-color: #fff;
    width: 240px;
    animation: drawer-open 0.3s;
    display: flex;
    flex-direction: column;
  }

  #header-mobile .blogger-site-link {
    margin-top: auto;
    margin-bottom: 24px;
  }

  #header-mobile .blogger-site-link a {
    color: var(--default, #3a3a3a) !important;
    font-family: 'Spoqa Han Sans Neo';
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  #header-mobile li a {
    display: block;
    padding: 12px 24px;
  }
  #header-mobile ul ul {
    position: relative;
  }

  #header-mobile.fade {
    display: none;
  }
  #header-mobile.close ul {
    left: -240px;
    animation: drawer-close 0.3s;
  }
  #header-mobile .profile {
    border-bottom: 1px solid #d0d0d0;
  }
  #header-mobile .scroll {
    overflow: auto;
    display: flex;
    flex-flow: column;
    height: 100%;
    max-height: calc(100% - 60px);
  }

  @keyframes drawer-open {
    from {
      left: -240px;
    }
    to {
      left: 0;
    }
  }
  @keyframes drawer-close {
    from {
      left: 0px;
    }
    to {
      left: -240px;
    }
  }
}

::v-deep .slick-slide {
  padding: 0;
  width: 100vw;
  /* width: 100%; */
  /* height: 100%; */
}
</style>
